import React from "react";
import "./_styles.scss";

interface LibraryCardProps {
  data?: any;
}

export default function LibraryCard({ data }: LibraryCardProps) {
  const { id, supplierName, email, userStatus } = data;
  const renderSwitch = (param: string) => {
    switch (param) {
      case "Accepted":
        return (
          <>
            <span className="badgeA">{data.userStatus}</span>
          </>
        );
      case "Pending":
        return (
          <>
            <span className="badgeB">{data.userStatus}</span>
          </>
        );
      case "Declined":
        return (
          <>
            <span className="badgeC">{data.userStatus}</span>
          </>
        );
      default:
        return "foo";
    }
  };
  return (
    <div className="module-p-library-card">
      <div>
        <img
          style={{
            maxWidth: 50,
            maxHeight: 50,
            objectFit: "contain",
            alignSelf: "center",
          }}
          src={data.supplierLogo}
        />
      </div>
      <div>
        <br />
      </div>
      <div>
        <h3 color="#1D84B5">{supplierName}</h3>
        <h4>{email}</h4>
        {data.userStatus !== null || data.userStatus !== "" ? (
          <>{renderSwitch(data.userStatus)}</>
        ) : (
          <></>
        )}
      </div>
      <div>
        <br />
      </div>
      <div>
        <br />
      </div>
    </div>
  );
}
